// extracted by mini-css-extract-plugin
export default {"sortableList":"vBIGBaK5M9"};